import './Icon_Trendingup.css';

function Icon_Trendingup() {
  return (
    
      <div className='trendingip-icon-container'>
          <svg viewBox="0 0 24 24" className="trendingup-icon-svg">
              <path d="M16 7h6v6"/><path d="m22 7-8.5 8.5-5-5L2 17"/>
          </svg>
      </div>
            
  );
}

export default Icon_Trendingup;

//<<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up-icon lucide-trending-up"><path d="M16 7h6v6"/><path d="m22 7-8.5 8.5-5-5L2 17"/></svg>